import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=7528a3da&"
import script from "./BaseLayout.vue?vue&type=script&lang=js&"
export * from "./BaseLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7528a3da')) {
      api.createRecord('7528a3da', component.options)
    } else {
      api.reload('7528a3da', component.options)
    }
    module.hot.accept("./BaseLayout.vue?vue&type=template&id=7528a3da&", function () {
      api.rerender('7528a3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/BaseLayout.vue"
export default component.exports